import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { DayPicker } from 'react-day-picker';

import { VFlex } from '../VFlex';
import { VTextButton } from '../VTextButton';
import type { DATEPICKER_MODE } from './constant';
import { DAYPICKER_BASE_PROPS } from './constant';
import useVDatePickerContext from './hook';
import style from './style';
import type { VDatePickerContentProps } from './type';
import { isSameDate } from './util';

const VDatePickerContent = ({ onClose, onSelect }: VDatePickerContentProps) => {
  const { value } = useVDatePickerContext<DATEPICKER_MODE.SINGLE>();
  const [innerValue, setInnerValue] = useState(dayjs(value).toDate());
  const [month, setMonth] = useState(dayjs(value).toDate());

  useEffect(() => {
    if (isSameDate(value, innerValue)) return;
    setInnerValue(dayjs(value).toDate());
    setMonth(dayjs(value).toDate());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <>
      <DayPicker
        {...DAYPICKER_BASE_PROPS}
        components={{
          ...DAYPICKER_BASE_PROPS.components,
          DayButton(props) {
            const {
              day: { date, outside },
            } = props;

            return (
              <button
                {...props}
                className={style.vDatePickerDayButton({
                  isToday: isSameDate(date, new Date()),
                  outside,
                  selected: isSameDate(date, innerValue),
                })}
              />
            );
          },
        }}
        month={month}
        // startMonth={new Date('2025-01-01T00:00:00+0900')}outside
        onMonthChange={setMonth}
        onDayClick={e => {
          setInnerValue(e);
        }}
      />
      <VFlex justify="between" className="w-full px-4 pb-4">
        <VTextButton onClick={onClose}>Cancel</VTextButton>
        <VTextButton onClick={() => onSelect(innerValue as Date)}>
          OK
        </VTextButton>
      </VFlex>
    </>
  );
};

export default VDatePickerContent;
